import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { FLEET_VEHICLE_CONTRACT_SALE_SEARCH_COLUMNS } from "./consts";
import { VehicleContractSaleSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const VehicleContractSaleSearchResults: React.FC<VehicleContractSaleSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onContactClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  const handleContactClick = (event: React.MouseEvent<HTMLDivElement>, id: string) => {
    if (onContactClick) onContactClick(event, id);
  };

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_CONTRACT_SALE_SEARCH_COLUMNS(t, handleContactClick, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};

export default memo(VehicleContractSaleSearchResults);